import { SelfMonitorSample } from '../../../types/SelfMonitor';

// A component-specific numeric extra from a sample (pool/executor counts,
// ingest counters), or 0 when absent - see JvmSample.extras.
export const extraNum = (sample: SelfMonitorSample | undefined, key: string): number => {
    if (!sample) return 0;
    const value = sample[key];
    return typeof value === 'number' ? value : 0;
};
